export function parseJSON(json) {
    // null/undefined는 바로 null 반환
    if (json == null)
        return null;
    // 문자열이면 JSON 파싱 시도
    if (typeof json === "string") {
        const s = json.trim();
        if (s === "")
            return null;
        try {
            return JSON.parse(s);
        }
        catch {
            return null;
        }
    }
    // 배열/객체 등은 그대로 반환
    return json;
}
